// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"Aq-z","outfitFeedbackSection":"Bq-z"};